import { render, staticRenderFns } from "./SingupSurvey.vue?vue&type=template&id=234b5931"
import script from "./SingupSurvey.vue?vue&type=script&lang=js"
export * from "./SingupSurvey.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports